import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20abstract%20background%20with%20warm%20coral%20and%20deep%20charcoal%20gradients%2C%20soft%20geometric%20shapes%20floating%2C%20luxurious%20theater%20vibe%2C%20elegant%20dramatic%20lighting%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20premium%20entertainment%20aesthetic&width=1800&height=900&seq=hero-bg-2026-jiujiu&orientation=landscape"
        alt="久久在线观看高清视频平台"
        title="久久在线观看 – 高清视频免费畅享平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          久久在线观看
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          海量高清视频资源，电影、电视剧、综艺、动漫应有尽有<br className="hidden sm:block" />
          无需下载，流畅播放，随时随地久久在线观看
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
          <div className="relative w-full">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
            </div>
            <input
              type="text"
              placeholder="搜索电影、电视剧、综艺..."
              className="w-full pl-11 pr-4 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white placeholder-white/50 text-sm border border-white/20 focus:outline-none focus:border-white/40 transition-colors"
            />
          </div>
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            立即观看
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">10万+</p>
            <p className="text-xs text-white/60 mt-1">视频资源</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">5000万+</p>
            <p className="text-xs text-white/60 mt-1">活跃用户</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">4K</p>
            <p className="text-xs text-white/60 mt-1">超清画质</p>
          </div>
        </div>
      </div>
    </section>
  );
}